import { visit } from 'unist-util-visit';
import type { Root, Strong } from 'mdast';
import type { Plugin } from 'unified';

export const UnderlinePlugin: Plugin<[], Root> = () => {
  return (tree, file) => {
    const src = String(file);

    // by default, "__"-nodes are parsed as strong (like "**")
    visit(tree, 'strong', (node: Strong, index, parent) => {
      if (!parent || index === undefined || !node.position) {
        return;
      }

      const { start, end } = node.position;
      const raw = src.slice(start.offset, end.offset);

      // Only retype nodes that were written with __ not **
      if (!raw.startsWith('__') || !raw.endsWith('__')) {
        return;
      }

      // Replace the strong node with an underline node
      parent.children.splice(index, 1, {
        type: 'underline',
        children: node.children,
        position: node.position,
        data: { hName: 'u' },
      });
    });
  };
};
